export const API_URL = import.meta.env.VITE_API_URL!;
export const STRIPE_PUBLISHABLE_KEY = import.meta.env
  .VITE_STRIPE_PUBLISHABLE_KEY!;
export const SUBSCRIPTION_PRICING_TABLE_ID = import.meta.env
  .VITE_SUBSCRIPTION_PRICING_TABLE_ID!;
export const SUBSCRIPTION_CUSTOMER_PORTAL_URL = import.meta.env
  .VITE_SUBSCRIPTION_CUSTOMER_PORTAL_URL!;
export const APP_VERSION = import.meta.env.VITE_VERSION || "local";
export const SITE_URL = (
  import.meta.env.VITE_SITE_URL || window.location.origin
).replace(/\/$/, "");
